var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLimsLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.8335 5H9.16679V9.44167L5.00012 15H15.0001L10.8335 9.44167V5Z",
    fill: "#66D1FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3334 15.3335L12.5001 8.89183V5.41683L13.6251 4.0085C13.8417 3.7335 13.6501 3.3335 13.3001 3.3335H6.70006C6.35006 3.3335 6.1584 3.7335 6.37506 4.0085L7.50006 5.41683V8.89183L2.66673 15.3335C2.2584 15.8835 2.65006 16.6668 3.3334 16.6668H16.6667C17.3501 16.6668 17.7417 15.8835 17.3334 15.3335ZM5.00006 15.0002L9.16673 9.44183V5.00016H10.8334V9.44183L15.0001 15.0002H5.00006Z",
    fill: "#66D1FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimsLogo);
export default __webpack_public_path__ + "static/media/LIMSLogo.7c29904f3c79576d790bb86107d3094a.svg";
export { ForwardRef as ReactComponent };